import { AfterViewInit, Directive, ElementRef, EventEmitter, NgZone, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[meetingSchedulerDatePickerNavigation]',
  standalone: true,
})
export class DatePickerNavigationDirective implements AfterViewInit, OnDestroy {
  @Output() prevClicked = new EventEmitter<void>();
  @Output() nextClicked = new EventEmitter<void>();

  private observer?: MutationObserver;
  private calendarId: string | null;

  constructor(
    private ngZone: NgZone,
    private host: ElementRef<HTMLElement>,
  ) {
    this.calendarId = this.host.nativeElement.getAttribute('data-calendar-id');
  }

  ngAfterViewInit(): void {
    if (!this.calendarId) {
      console.warn('[DatePickerNavigationDirective] data-calendar-id attribute is required on mat-datepicker-toggle!');
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of Array.from(mutation.addedNodes)) {
            if (node instanceof HTMLElement && node.querySelector('.mat-calendar')) {
              const calendarEl = node.querySelector('.mat-calendar');
              if (calendarEl) {
                calendarEl.setAttribute('data-calendar-id', this.calendarId);

                if (calendarEl.getAttribute('data-calendar-id') === this.calendarId) {
                  this.attachButtonListeners(calendarEl);
                }
              }
              return;
            }
          }
        }
      });

      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  private attachButtonListeners(calendarEl: Element) {
    const prevButton = calendarEl.querySelector('button.mat-calendar-previous-button');
    const nextButton = calendarEl.querySelector('button.mat-calendar-next-button');

    if (prevButton && !prevButton.hasAttribute('data-api-hooked')) {
      prevButton.setAttribute('data-api-hooked', 'true');
      prevButton.addEventListener('click', () => {
        this.ngZone.run(() => {
          this.prevClicked.emit();
        });
      });
    }

    if (nextButton && !nextButton.hasAttribute('data-api-hooked')) {
      nextButton.setAttribute('data-api-hooked', 'true');
      nextButton.addEventListener('click', () => {
        this.ngZone.run(() => {
          this.nextClicked.emit();
        });
      });
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
